@for (item of groups(); track item.folderId) {
    @if (item.group; as group) {
        <div
            class="credit-group flex flex-wrap gap align-items-center justify-content-between p-2"
            [style.border-left-color]="group.color"
        >
            @if (folderIds().length > 1) {
                <div class="font-bold">{{ item.person?.name }} {{ item.person?.surname }}</div>
            }
            <div class="font-bold">{{ group.name }}</div>
            <div class="flex gap-small">
                <div>{{ 'socialCredits.movements.balance' | translate }}:</div>
                <div class="font-bold">{{ item.balance | formatNumber: 2 : true }}</div>
            </div>
            <div class="flex gap-small">
                <div>
                    {{ (workId() || replacedWorkIds().length
                        ? 'socialCredits.work.newPayments' : 'socialCredits.work.requiredCredits') | translate }}:
                </div>
                <div class="font-bold">{{ item.requiredCredits | formatNumber: 2 : true }}</div>
            </div>
            @if (item.releasedCredits) {
                <div class="flex gap-small">
                    <div>{{ 'socialCredits.work.releasedCredits' | translate }}:</div>
                    <div class="font-bold">{{ item.releasedCredits | formatNumber: 2 : true }}</div>
                </div>
            }
            @if (item.requiredCredits > item.availableCredits) {
                <div
                    class="text-danger w-full"
                    role="alert"
                >
                    {{ 'socialCredits.work.insufficientBalance' | translate }}
                    <button
                        type="button"
                        class="purchase-link"
                        [disabled]="!canPurchase()"
                        (click)="purchaseCredits(item.folderId, item.requiredCredits, item.availableCredits)"
                    >{{ 'socialCredits.work.buyCredits' | translate }}</button>.
                </div>
            }
        </div>
    }
}
